import { Reducer } from "redux";

import { PsychologicalHistoryResponse } from "../models/Api/Master";
import { PsychologicalHistoryActionDispatchTypes } from "../constants/Master";
import { PsychologicalHistoryDispatchTypes } from "../models/DispatchTypes/Master";
import { setLocalStorageData } from "../utils";

const initialState: PsychologicalHistoryResponse = {
  loading: false,
  response: [],
};

const PsychologicalHistoryReducer: Reducer<
  PsychologicalHistoryResponse,
  PsychologicalHistoryDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_SUCCESS: {
      setLocalStorageData(
        PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default PsychologicalHistoryReducer;
